/**
 * What the AI assistant is told when a supplier notification field is hidden or read-only by company policy.
 * Those settings belong to the customer — the company the notification is for (the detail page loads them for
 * `customerCompany`) — not to the supplier filling the notification in: the assistant tells a supplier to ask
 * the customer, and the customer's own user that an administrator can change them.
 *
 * Used in the policy clauses of the create page, the detail page and the order fields, which are written out in
 * full at each call site: `{ type: 'custom', label, satisfied, description: POLICY_DESCRIPTION.visible, byDesign: false }`.
 */
export const POLICY_DESCRIPTION = {
  visible: "Hidden by the customer's supplier notification settings; set by the customer, not the supplier",
  editable: "Read-only by the customer's supplier notification settings; set by the customer, not the supplier",
};
